var map = {
	"./Add-icon.svg": "./src/assets/img/Add-icon.svg",
	"./Trash-icon.svg": "./src/assets/img/Trash-icon.svg",
	"./Vector 4.svg": "./src/assets/img/Vector 4.svg",
	"./bell_concierge.svg": "./src/assets/img/bell_concierge.svg",
	"./carousel.svg": "./src/assets/img/carousel.svg",
	"./carousel/signup_carousel_0.svg": "./src/assets/img/carousel/signup_carousel_0.svg",
	"./carousel/signup_carousel_1.svg": "./src/assets/img/carousel/signup_carousel_1.svg",
	"./carousel/signup_carousel_2.svg": "./src/assets/img/carousel/signup_carousel_2.svg",
	"./carousel/signup_carousel_3.svg": "./src/assets/img/carousel/signup_carousel_3.svg",
	"./check_mark_accept_icon.svg": "./src/assets/img/check_mark_accept_icon.svg",
	"./check_mark_accept_icon_grey.svg": "./src/assets/img/check_mark_accept_icon_grey.svg",
	"./chevron_double_down_o_icon.svg": "./src/assets/img/chevron_double_down_o_icon.svg",
	"./compress.svg": "./src/assets/img/compress.svg",
	"./content_loader/reporting_info_numbers.svg": "./src/assets/img/content_loader/reporting_info_numbers.svg",
	"./content_loader/reporting_posts_content.svg": "./src/assets/img/content_loader/reporting_posts_content.svg",
	"./content_loader/reporting_posts_date.svg": "./src/assets/img/content_loader/reporting_posts_date.svg",
	"./content_loader/reporting_posts_numbers.svg": "./src/assets/img/content_loader/reporting_posts_numbers.svg",
	"./content_loader/reporting_posts_reaction.svg": "./src/assets/img/content_loader/reporting_posts_reaction.svg",
	"./copy_icon.svg": "./src/assets/img/copy_icon.svg",
	"./csv.svg": "./src/assets/img/csv.svg",
	"./dailymotion-source.svg": "./src/assets/img/dailymotion-source.svg",
	"./document_app_essential_icon.svg": "./src/assets/img/document_app_essential_icon.svg",
	"./drag-list.svg": "./src/assets/img/drag-list.svg",
	"./drag-list2.svg": "./src/assets/img/drag-list2.svg",
	"./fb.svg": "./src/assets/img/fb.svg",
	"./flag/france.svg": "./src/assets/img/flag/france.svg",
	"./flag/germany.svg": "./src/assets/img/flag/germany.svg",
	"./flag/portugal.svg": "./src/assets/img/flag/portugal.svg",
	"./flag/spain.svg": "./src/assets/img/flag/spain.svg",
	"./flag/united-kingdom.svg": "./src/assets/img/flag/united-kingdom.svg",
	"./google-news-source.svg": "./src/assets/img/google-news-source.svg",
	"./google.svg": "./src/assets/img/google.svg",
	"./hashtag_black.svg": "./src/assets/img/hashtag_black.svg",
	"./hashtag_white.svg": "./src/assets/img/hashtag_white.svg",
	"./header/nav/Menu-icon.svg": "./src/assets/img/header/nav/Menu-icon.svg",
	"./header/nav/arrow-left-right.svg": "./src/assets/img/header/nav/arrow-left-right.svg",
	"./header/nav/ico-gear.svg": "./src/assets/img/header/nav/ico-gear.svg",
	"./header/nav/ico-invoice.svg": "./src/assets/img/header/nav/ico-invoice.svg",
	"./header/nav/ico-support.svg": "./src/assets/img/header/nav/ico-support.svg",
	"./header/nav/log-out.svg": "./src/assets/img/header/nav/log-out.svg",
	"./header/nav/pwa-install.svg": "./src/assets/img/header/nav/pwa-install.svg",
	"./ico-check.svg": "./src/assets/img/ico-check.svg",
	"./ico-export.svg": "./src/assets/img/ico-export.svg",
	"./ico-import.svg": "./src/assets/img/ico-import.svg",
	"./ico-inqueue.svg": "./src/assets/img/ico-inqueue.svg",
	"./ico-instagram-circle.svg": "./src/assets/img/ico-instagram-circle.svg",
	"./ico-linkedin-circle.svg": "./src/assets/img/ico-linkedin-circle.svg",
	"./ico-man.svg": "./src/assets/img/ico-man.svg",
	"./ico-posting.svg": "./src/assets/img/ico-posting.svg",
	"./ico-scheduled.svg": "./src/assets/img/ico-scheduled.svg",
	"./ico-search.svg": "./src/assets/img/ico-search.svg",
	"./ico-threads-circle.svg": "./src/assets/img/ico-threads-circle.svg",
	"./ico-twitter-circle.svg": "./src/assets/img/ico-twitter-circle.svg",
	"./ico-whatsapp-circle.svg": "./src/assets/img/ico-whatsapp-circle.svg",
	"./ico-youtube-circle.svg": "./src/assets/img/ico-youtube-circle.svg",
	"./icon-RAZ.svg": "./src/assets/img/icon-RAZ.svg",
	"./icon-checkup.svg": "./src/assets/img/icon-checkup.svg",
	"./icon-delete.svg": "./src/assets/img/icon-delete.svg",
	"./icon-hide-group-1.svg": "./src/assets/img/icon-hide-group-1.svg",
	"./icon-hide-group.svg": "./src/assets/img/icon-hide-group.svg",
	"./icon-left-arrow.svg": "./src/assets/img/icon-left-arrow.svg",
	"./icon-right-arrow.svg": "./src/assets/img/icon-right-arrow.svg",
	"./icon-show-group-1.svg": "./src/assets/img/icon-show-group-1.svg",
	"./icon-show-group.svg": "./src/assets/img/icon-show-group.svg",
	"./icon_bell_notification_ting_pink.svg": "./src/assets/img/icon_bell_notification_ting_pink.svg",
	"./icon_blacklist.svg": "./src/assets/img/icon_blacklist.svg",
	"./icon_bluesky.svg": "./src/assets/img/icon_bluesky.svg",
	"./icon_check.svg": "./src/assets/img/icon_check.svg",
	"./icon_check_black.svg": "./src/assets/img/icon_check_black.svg",
	"./icon_check_dark.svg": "./src/assets/img/icon_check_dark.svg",
	"./icon_check_grey.svg": "./src/assets/img/icon_check_grey.svg",
	"./icon_check_light.svg": "./src/assets/img/icon_check_light.svg",
	"./icon_check_mid.svg": "./src/assets/img/icon_check_mid.svg",
	"./icon_check_purple.svg": "./src/assets/img/icon_check_purple.svg",
	"./icon_check_white.svg": "./src/assets/img/icon_check_white.svg",
	"./icon_connect_pink.svg": "./src/assets/img/icon_connect_pink.svg",
	"./icon_connect_white.svg": "./src/assets/img/icon_connect_white.svg",
	"./icon_date.svg": "./src/assets/img/icon_date.svg",
	"./icon_delete.svg": "./src/assets/img/icon_delete.svg",
	"./icon_export.svg": "./src/assets/img/icon_export.svg",
	"./icon_flash_black.svg": "./src/assets/img/icon_flash_black.svg",
	"./icon_flash_white.svg": "./src/assets/img/icon_flash_white.svg",
	"./icon_heart_full.svg": "./src/assets/img/icon_heart_full.svg",
	"./icon_heart_full_red.svg": "./src/assets/img/icon_heart_full_red.svg",
	"./icon_help.svg": "./src/assets/img/icon_help.svg",
	"./icon_import.svg": "./src/assets/img/icon_import.svg",
	"./icon_instagram_crop.svg": "./src/assets/img/icon_instagram_crop.svg",
	"./icon_instagram_inverse_x.svg": "./src/assets/img/icon_instagram_inverse_x.svg",
	"./icon_instagram_inverse_y.svg": "./src/assets/img/icon_instagram_inverse_y.svg",
	"./icon_instagram_link.svg": "./src/assets/img/icon_instagram_link.svg",
	"./icon_instagram_loupe_moins.svg": "./src/assets/img/icon_instagram_loupe_moins.svg",
	"./icon_instagram_loupe_plus.svg": "./src/assets/img/icon_instagram_loupe_plus.svg",
	"./icon_instagram_pencil.svg": "./src/assets/img/icon_instagram_pencil.svg",
	"./icon_instagram_reel.svg": "./src/assets/img/icon_instagram_reel.svg",
	"./icon_instagram_rotate.svg": "./src/assets/img/icon_instagram_rotate.svg",
	"./icon_instagram_rotate_neg.svg": "./src/assets/img/icon_instagram_rotate_neg.svg",
	"./icon_instagram_rotate_txt.svg": "./src/assets/img/icon_instagram_rotate_txt.svg",
	"./icon_instagram_swipe_up.svg": "./src/assets/img/icon_instagram_swipe_up.svg",
	"./icon_instagram_trash.svg": "./src/assets/img/icon_instagram_trash.svg",
	"./icon_launch.svg": "./src/assets/img/icon_launch.svg",
	"./icon_more.svg": "./src/assets/img/icon_more.svg",
	"./icon_paperclip.svg": "./src/assets/img/icon_paperclip.svg",
	"./icon_people.svg": "./src/assets/img/icon_people.svg",
	"./icon_post.svg": "./src/assets/img/icon_post.svg",
	"./icon_post_black.svg": "./src/assets/img/icon_post_black.svg",
	"./icon_refresh_reload.svg": "./src/assets/img/icon_refresh_reload.svg",
	"./icon_round_check.svg": "./src/assets/img/icon_round_check.svg",
	"./icon_rss.svg": "./src/assets/img/icon_rss.svg",
	"./icon_stop.svg": "./src/assets/img/icon_stop.svg",
	"./icon_time_black.svg": "./src/assets/img/icon_time_black.svg",
	"./icon_time_grey.svg": "./src/assets/img/icon_time_grey.svg",
	"./icon_time_white.svg": "./src/assets/img/icon_time_white.svg",
	"./icon_tree_dot.svg": "./src/assets/img/icon_tree_dot.svg",
	"./icon_twitter.svg": "./src/assets/img/icon_twitter.svg",
	"./icon_unlock.svg": "./src/assets/img/icon_unlock.svg",
	"./icon_validate_white.svg": "./src/assets/img/icon_validate_white.svg",
	"./icon_wait_black.svg": "./src/assets/img/icon_wait_black.svg",
	"./icon_wait_grey.svg": "./src/assets/img/icon_wait_grey.svg",
	"./icon_wait_proxy.svg": "./src/assets/img/icon_wait_proxy.svg",
	"./icon_wait_white.svg": "./src/assets/img/icon_wait_white.svg",
	"./icon_warn.svg": "./src/assets/img/icon_warn.svg",
	"./input/custom.svg": "./src/assets/img/input/custom.svg",
	"./input/instagram-post.svg": "./src/assets/img/input/instagram-post.svg",
	"./input/instagram-story.svg": "./src/assets/img/input/instagram-story.svg",
	"./input/mashup.svg": "./src/assets/img/input/mashup.svg",
	"./input/no-text.svg": "./src/assets/img/input/no-text.svg",
	"./input/none.svg": "./src/assets/img/input/none.svg",
	"./input/text-desc.svg": "./src/assets/img/input/text-desc.svg",
	"./input/text-img.svg": "./src/assets/img/input/text-img.svg",
	"./input/text-only.svg": "./src/assets/img/input/text-only.svg",
	"./input/text-title.svg": "./src/assets/img/input/text-title.svg",
	"./input/text-video.svg": "./src/assets/img/input/text-video.svg",
	"./insta.svg": "./src/assets/img/insta.svg",
	"./legal-icon.svg": "./src/assets/img/legal-icon.svg",
	"./linkedin.svg": "./src/assets/img/linkedin.svg",
	"./linkedin_link_title.svg": "./src/assets/img/linkedin_link_title.svg",
	"./linkedin_snippet.svg": "./src/assets/img/linkedin_snippet.svg",
	"./logo-youtube.svg": "./src/assets/img/logo-youtube.svg",
	"./mentions_black.svg": "./src/assets/img/mentions_black.svg",
	"./mentions_white.svg": "./src/assets/img/mentions_white.svg",
	"./no-picture.svg": "./src/assets/img/no-picture.svg",
	"./pdf_reference_icon.svg": "./src/assets/img/pdf_reference_icon.svg",
	"./percent_promo_icon.svg": "./src/assets/img/percent_promo_icon.svg",
	"./pinterest-source.svg": "./src/assets/img/pinterest-source.svg",
	"./pinterest.svg": "./src/assets/img/pinterest.svg",
	"./prefix_suffix_black.svg": "./src/assets/img/prefix_suffix_black.svg",
	"./prefix_suffix_white.svg": "./src/assets/img/prefix_suffix_white.svg",
	"./reporting_icons/angry.svg": "./src/assets/img/reporting_icons/angry.svg",
	"./reporting_icons/clic.svg": "./src/assets/img/reporting_icons/clic.svg",
	"./reporting_icons/engagement.svg": "./src/assets/img/reporting_icons/engagement.svg",
	"./reporting_icons/fans.svg": "./src/assets/img/reporting_icons/fans.svg",
	"./reporting_icons/haha.svg": "./src/assets/img/reporting_icons/haha.svg",
	"./reporting_icons/impression.svg": "./src/assets/img/reporting_icons/impression.svg",
	"./reporting_icons/like.svg": "./src/assets/img/reporting_icons/like.svg",
	"./reporting_icons/love.svg": "./src/assets/img/reporting_icons/love.svg",
	"./reporting_icons/posts.svg": "./src/assets/img/reporting_icons/posts.svg",
	"./reporting_icons/sad.svg": "./src/assets/img/reporting_icons/sad.svg",
	"./reporting_icons/wow.svg": "./src/assets/img/reporting_icons/wow.svg",
	"./rss-source.svg": "./src/assets/img/rss-source.svg",
	"./rss/icon_clicks.svg": "./src/assets/img/rss/icon_clicks.svg",
	"./rss/icon_comments.svg": "./src/assets/img/rss/icon_comments.svg",
	"./rss/icon_likes.svg": "./src/assets/img/rss/icon_likes.svg",
	"./rss/icon_retweet.svg": "./src/assets/img/rss/icon_retweet.svg",
	"./rss/icon_saved.svg": "./src/assets/img/rss/icon_saved.svg",
	"./rss/icon_shares.svg": "./src/assets/img/rss/icon_shares.svg",
	"./rss/icon_vues.svg": "./src/assets/img/rss/icon_vues.svg",
	"./select_all_icon.svg": "./src/assets/img/select_all_icon.svg",
	"./source-search_type-search.svg": "./src/assets/img/source-search_type-search.svg",
	"./source-search_type-tag.svg": "./src/assets/img/source-search_type-tag.svg",
	"./source-search_type-user.svg": "./src/assets/img/source-search_type-user.svg",
	"./star_icon.svg": "./src/assets/img/star_icon.svg",
	"./tabs/Bots-icon-white.svg": "./src/assets/img/tabs/Bots-icon-white.svg",
	"./tabs/Bots-icon.svg": "./src/assets/img/tabs/Bots-icon.svg",
	"./tabs/Moderation-icon.svg": "./src/assets/img/tabs/Moderation-icon.svg",
	"./tabs/Overview-icon.svg": "./src/assets/img/tabs/Overview-icon.svg",
	"./tabs/Pages-icon.svg": "./src/assets/img/tabs/Pages-icon.svg",
	"./tabs/Planner-icon.svg": "./src/assets/img/tabs/Planner-icon.svg",
	"./tabs/Posts-icon.svg": "./src/assets/img/tabs/Posts-icon.svg",
	"./tabs/Reporting-icon.svg": "./src/assets/img/tabs/Reporting-icon.svg",
	"./tabs/Sources-icon.svg": "./src/assets/img/tabs/Sources-icon.svg",
	"./tabs/ico-bots.svg": "./src/assets/img/tabs/ico-bots.svg",
	"./tabs/ico-export.svg": "./src/assets/img/tabs/ico-export.svg",
	"./tabs/ico-import.svg": "./src/assets/img/tabs/ico-import.svg",
	"./tabs/ico-moderation.svg": "./src/assets/img/tabs/ico-moderation.svg",
	"./tabs/ico-overview.svg": "./src/assets/img/tabs/ico-overview.svg",
	"./tabs/ico-pages.svg": "./src/assets/img/tabs/ico-pages.svg",
	"./tabs/ico-planner.svg": "./src/assets/img/tabs/ico-planner.svg",
	"./tabs/ico-posts.svg": "./src/assets/img/tabs/ico-posts.svg",
	"./tabs/ico-reporting.svg": "./src/assets/img/tabs/ico-reporting.svg",
	"./tabs/ico-settings.svg": "./src/assets/img/tabs/ico-settings.svg",
	"./tabs/ico-sources.svg": "./src/assets/img/tabs/ico-sources.svg",
	"./tabs/⁫ico-pages.svg": "./src/assets/img/tabs/⁫ico-pages.svg",
	"./telegram.svg": "./src/assets/img/telegram.svg",
	"./tiktok-iconbar.svg": "./src/assets/img/tiktok-iconbar.svg",
	"./tw.svg": "./src/assets/img/tw.svg",
	"./twitter-source.svg": "./src/assets/img/twitter-source.svg",
	"./unselect_icon.svg": "./src/assets/img/unselect_icon.svg",
	"./video-icon.svg": "./src/assets/img/video-icon.svg",
	"./vimeo-source.svg": "./src/assets/img/vimeo-source.svg",
	"./youtube-source.svg": "./src/assets/img/youtube-source.svg",
	"./zip_reference_icon.svg": "./src/assets/img/zip_reference_icon.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img sync recursive ^\\.\\/.*\\.svg$";